var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader-overlay",style:({'display': _vm.show ? 'block' : 'none'}),attrs:{"id":"preloader"}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"status"}},[_c('div',{staticClass:"spinner"},[_c('i',{staticClass:"ri-loader-line spin-icon"})])])
}]

export { render, staticRenderFns }